import { MediaActivationRoot, UnsafeScreenRoot } from "types";

export const MediaActivationRootDefinition: UnsafeScreenRoot = {
  name: MediaActivationRoot,
  routePath: ["/media-activation/*"],
};
